<template>
	<div class="wrap wrap_finance">
		<SpacedSquareTab :items="subTabItems" />
		<div v-if="headerStore.getCountry === 'KR'">
			<FinanceStatementKR v-if="$route.query.sub === '재무제표' || !$route.query.sub" />
			<FinanceChartKR v-if="$route.query.sub === '재무차트'" />
			<FinanceIndicatorKR v-if="$route.query.sub === '투자지표'" />
		</div>
		<div v-else-if="headerStore.getCountry === 'JPN'">
			<FinanceStatementJPN v-if="$route.query.sub === '재무제표' || !$route.query.sub" />
			<FinanceChartJPN v-if="$route.query.sub === '재무차트'" />
			<FinanceIndicatorJPN v-if="$route.query.sub === '투자지표'" />
		</div>
		<div v-else>
			<FinanceStatement v-if="$route.query.sub === '재무제표' || !$route.query.sub" />
			<FinanceChart v-if="$route.query.sub === '재무차트'" />
			<FinanceIndicator v-if="$route.query.sub === '투자지표'" />
		</div>
	</div>
</template>

<script setup lang="ts">
// component
import SpacedSquareTab from '@/components/atom/tabBar/SpacedSquareTab.vue';
import FinanceChartKR from '@/components/report/kr/FinanceChartKR.vue';
import FinanceIndicatorKR from '@/components/report/kr/FinanceIndicatorKR.vue';
import FinanceStatementKR from '@/components/report/kr/FinanceStatementKR.vue';
import FinanceChart from '@/components/report/usa/FinanceChartUSA.vue';
import FinanceIndicator from '@/components/report/usa/FinanceIndicatorUSA.vue';
import FinanceStatement from '@/components/report/usa/FinanceStatementUSA.vue';
import FinanceChartJPN from '@/components/report/jpn/FinanceChartJPN.vue';
import FinanceIndicatorJPN from '@/components/report/jpn/FinanceIndicatorJPN.vue';
import FinanceStatementJPN from '@/components/report/jpn/FinanceStatementJPN.vue';
import { useHeaderStore } from '@/stores/header';

// -----variable-----
const headerStore = useHeaderStore();
const subTabItems = ['재무제표', '재무차트', '투자지표'];
</script>

<style scoped lang="scss"></style>
